import { Reveal } from "./Reveal";

export default function SectionHeader({ index, eyebrow, title, sub, tone = "light", className = "" }) {
  return (
    <Reveal className={`max-w-2xl ${className}`}>
      <p
        className="font-mono text-xs font-medium uppercase tracking-[0.2em] text-gold-deep"
        data-testid={`section-eyebrow-${index}`}
      >
        {index && `${index} · `}{eyebrow}
      </p>
      <h2 className="mt-3 text-2xl font-bold leading-snug tracking-tight text-navy-900 sm:text-3xl">
        {title}
      </h2>
      {sub && <p className="mt-3 text-[15px] leading-relaxed text-ink sm:text-base">{sub}</p>}
    </Reveal>
  );
}
